import { render, staticRenderFns } from "./lvzhi_list.vue?vue&type=template&id=4403da4d&scoped=true&"
import script from "./lvzhi_list.vue?vue&type=script&lang=js&"
export * from "./lvzhi_list.vue?vue&type=script&lang=js&"
import style0 from "./lvzhi_list.vue?vue&type=style&index=0&id=4403da4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4403da4d",
  null
  
)

export default component.exports